import TableHeaderPlugin from '@tiptap/extension-table-header'
import './Table.scss'

export const TableHeader = TableHeaderPlugin.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      style: {
        default: 'border: 1px solid black; background-color: rgb(180,180,180); border-spacing: 0;',
        parseHTML: (element) => element.style?.cssText || '',
        renderHTML: (attributes) => ({ style: attributes['style'] }),
      },
    }
  },
})
